import { Navigate } from 'react-router-dom';
import React from 'react';
import { AuthProvider } from '@propelauth/react';
import { GoogleOAuthProvider } from '@react-oauth/google';
import MainLayout from '../dashboard/MainLayout';
import OrderPage from '../order_page/OrderPage';
import OrderCompletedPage from '../order_page/orderCompletion/OrderCompletedPage';
import Orders from '../orders/Orders';
import Calendar from '../calendar/calendarWrapper/CalendarWrapper';
import { CalendarProvider } from '../calendar/CalendarContext/CalendarContext';
import OrderPages from '../orders/OrderPages';
import ChooseOrderPage from '../order_page/ChooseOrderPage';
import { CommonDialogsProvider } from './dialogs/CommonDialogsContext';
import WaitingList from '../order_page/WaitingList';
import WaitingListCompletedPage from '../order_page/WaitingListCompletedPage';
import AuthGuard from '../session/AuthGuard';
import InternalAuthProvider from '../session/InternalAuthProvider';
import { CustomerFacingWidgetWrapper } from './ui/CustomerFacingWidgetWrapper';
import { ManageBookingWizard } from '../manageBookingPage/ManageBookingWizard';
import { PaymentLinksWizard } from '../customerPaymentLinksPage/CustomerPaymentLinksPage';
import VouchersTable from '../vouchers/VouchersTable';
import { TermsComponent } from '../terms/Terms';
import { OrderPageSettingsPage } from '../experienceSettings/OrderPageSettingsPage';
import { AccountSettingsPage } from '../accountSettings/AccountSettingsPage';
import { PrivacyComponent } from '../terms/Privacy';
import { AccountSpecificThemeWrapper } from '../order_page/AccountSpecificThemeWrapper';
import { GATest } from './GATest';
import { EmailTemplatesPage } from '../emailTemplates/EmailTemplatesPage';
import { SMSTemplatesPage } from '../smsTemplates/SMSTemplatesPage';
import { WhatsAppSettingsPage } from '../whatsappSettings/WhatsAppSettingsPage';
import { DiscountsPage } from '../discounts/DiscountsPage';
import { CreateExperiencePage } from '../createExperiencePage/CreateExperiencePage';
import { ReportsPage } from '../reports/ReportsPage';
import { StripePage } from '../stripe/StripePage';
import { WaitingListTable } from '../waitingList/WaitingListTable';
import { PaymentLinkTable } from '../paymentLinks/PaymentLinkTable';
import { OrderPageProvider } from '../order_page/orderPageContext/OrderPageProvider';
import { MultipleOrderPage } from '../order_page/multipleOrderPages/MultipleOrderPage';
import { WidgetThemeProvider } from '../order_page/theme/Theme';
import { UserSettingsPage } from '../userSettings/UserSettingsPage';
import { VoucherSelectionWidget } from '../order_page/multipleVouchersPage';
import { PaperPage } from './PaperPage';
import { ExtendedDashboard } from '../orders/dashboards/ExtendedDashboard';
import { CompleteRequestedOrder } from '../completeRequestedOrder/CompleteRequestedOrder';
import { ApiResponseHandlerProvider } from './apiNotifications/ApiResponseHandlerContext';
import { AuditLogPage } from '../auditLog/AuditLogPage';
import { SvixPortalSettings } from '../accountSettings/SvixPortalSettings';

const routes = [
  {
    element: (
      <AuthProvider authUrl={import.meta.env.VITE_REACT_APP_AUTH_URL}>
        <InternalAuthProvider>
          <AuthGuard>
            <GoogleOAuthProvider clientId="432245203095-crb38f5c51ae987r0vkguv5o9h95gb85.apps.googleusercontent.com">
              <ApiResponseHandlerProvider>
                <CommonDialogsProvider>
                  <WidgetThemeProvider
                    remoteThemeOverride={{
                      typography: {
                        fontFamily: 'Assistant',
                      },
                    }}>
                    <MainLayout />
                  </WidgetThemeProvider>
                </CommonDialogsProvider>
              </ApiResponseHandlerProvider>
            </GoogleOAuthProvider>
          </AuthGuard>
        </InternalAuthProvider>
      </AuthProvider>
    ),
    children: [
      {
        path: '/dashboard/calendar/:startDate?',
        element: (
          <CalendarProvider>
            <Calendar />
          </CalendarProvider>
        ),
      },
      {
        path: '/dashboard/orders',
        element: (
          <CalendarProvider>
            <PaperPage>
              <Orders />
            </PaperPage>
          </CalendarProvider>
        ),
      },
      {
        path: '/dashboard/vouchers',
        element: (
          <CalendarProvider>
            <PaperPage>
              <VouchersTable />
            </PaperPage>
          </CalendarProvider>
        ),
      },
      {
        path: '/dashboard/discounts',
        element: (
          <PaperPage>
            <DiscountsPage />
          </PaperPage>
        ),
      },
      {
        path: '/dashboard/create-experience',
        element: (
          <PaperPage>
            <CreateExperiencePage />
          </PaperPage>
        ),
      },
      {
        path: '/dashboard/user-settings',
        element: (
          <PaperPage>
            <UserSettingsPage />
          </PaperPage>
        ),
      },
      {
        path: '/dashboard/account-settings',
        element: (
          <PaperPage>
            <AccountSettingsPage />
          </PaperPage>
        ),
      },
      {
        path: '/dashboard/email-templates',
        element: (
          <PaperPage>
            <EmailTemplatesPage />
          </PaperPage>
        ),
      },
      {
        path: '/dashboard/webhooks',
        element: (
          <PaperPage>
            <SvixPortalSettings />
          </PaperPage>
        ),
      },
      {
        path: '/dashboard/sms-templates',
        element: (
          <PaperPage>
            <SMSTemplatesPage />
          </PaperPage>
        ),
      },
      {
        path: '/dashboard/whatsapp-settings',
        element: (
          <PaperPage>
            <WhatsAppSettingsPage />
          </PaperPage>
        ),
      },
      {
        path: '/dashboard/settings/:orderPageId',
        element: (
          <PaperPage>
            <OrderPageSettingsPage />
          </PaperPage>
        ),
      },
      {
        path: '/dashboard/order-pages',
        element: (
          <PaperPage>
            <OrderPages />
          </PaperPage>
        ),
      },
      {
        path: '/dashboard/analytics',
        element: (
          <PaperPage>
            <ExtendedDashboard />
          </PaperPage>
        ),
      },
      {
        path: '/dashboard/waiting-list',
        element: (
          <CalendarProvider>
            <PaperPage>
              <WaitingListTable />
            </PaperPage>
          </CalendarProvider>
        ),
      },
      {
        path: '/dashboard/payment-links',
        element: (
          <CalendarProvider>
            <PaperPage>
              <PaymentLinkTable />
            </PaperPage>
          </CalendarProvider>
        ),
      },
      {
        path: '/dashboard/reports',
        element: (
          <PaperPage>
            <ReportsPage />
          </PaperPage>
        ),
      },
      {
        path: '/dashboard/stripe',
        element: (
          <PaperPage>
            <StripePage />
          </PaperPage>
        ),
      },
      {
        path: '/dashboard/audit-log',
        element: (
          <PaperPage>
            <AuditLogPage />
          </PaperPage>
        ),
      },
    ],
  },
  {
    path: '/',
    element: <Navigate to="/dashboard" />,
  },
  { path: '/dashboard', element: <Navigate to="/dashboard/calendar" /> },
  {
    path: '/dashboard/default',
    element: <Navigate to="/dashboard/calendar" />,
  },
  {
    path: '/order/completed',
    element: (
      <AccountSpecificThemeWrapper>
        <OrderCompletedPage />
      </AccountSpecificThemeWrapper>
    ),
  },
  { path: '/waiting-list/completed', element: <WaitingListCompletedPage /> },
  {
    path: '/choose-order/:accountId/',
    element: <ChooseOrderPage />,
  },
  {
    path: '/order/:accountId/',
    element: (
      <AccountSpecificThemeWrapper>
        <MultipleOrderPage />
      </AccountSpecificThemeWrapper>
    ),
  },
  {
    path: '/giftcards/:accountId',
    element: (
      <AccountSpecificThemeWrapper>
        <VoucherSelectionWidget />
      </AccountSpecificThemeWrapper>
    ),
  },
  {
    path: '/order/:accountId/:experienceId/:orderPageId',
    element: (
      <OrderPageProvider>
        <OrderPage />
      </OrderPageProvider>
    ),
  },
  {
    path: '/order/:accountId/:experienceId',
    element: (
      <OrderPageProvider>
        <OrderPage />
      </OrderPageProvider>
    ),
  },
  {
    path: '/order/:accountId',
    element: (
      <OrderPageProvider>
        <OrderPage />
      </OrderPageProvider>
    ),
  },
  {
    path: '/waiting-list/:accountId/:experienceId/:orderPageId/:persons/:date',
    element: (
      <AccountSpecificThemeWrapper>
        <WaitingList />
      </AccountSpecificThemeWrapper>
    ),
  },
  {
    path: '/manage-booking',
    element: (
      <CustomerFacingWidgetWrapper>
        <ManageBookingWizard />
      </CustomerFacingWidgetWrapper>
    ),
  },
  {
    path: '/payment-link',
    element: (
      <CustomerFacingWidgetWrapper>
        <PaymentLinksWizard />
      </CustomerFacingWidgetWrapper>
    ),
  },
  {
    path: '/terms',
    element: <TermsComponent />,
  },

  {
    path: '/gatest',
    element: <GATest />,
  },
  {
    path: '/privacy',
    element: <PrivacyComponent />,
  },
  {
    path: '/complete-requested/:accountId',
    element: (
      <AccountSpecificThemeWrapper>
        <CompleteRequestedOrder />
      </AccountSpecificThemeWrapper>
    ),
  },
  { path: '*', element: <div>Not found</div> },
];

export default routes;
